import { getLocation } from '@/utils/ssrCompatible'
import { session } from '@/utils/storage'
import { routeFixList } from '@/config/country'

// 不同国家的前缀 重定向首页。
export const ROUTE_FIX = routeFixList()

// 路由路径是否包含国家前缀\ type 是否去除反斜杠
export const routeEventFix = (path) => {
  const { pathname = '' } = session.get('_location') || {}
  const _path = path.indexOf('/') !== -1 ? path : `/${path}`
  // 指定pathname 必须是 /br/xx
  const lastIndex = pathname.lastIndexOf('/') >= 3

  if (lastIndex) {
    return `${pathname.slice(0, 3)}${_path}`
  } else {
    // 再次判断如果是： /br 、 /my 、/id 等
    const result = ROUTE_FIX.some((item) => pathname === item)

    if (result) {
      return `${pathname.slice(0, 3)}${_path}`
    }
  }

  return _path
}

// 路由路径是否包含国家前缀\ type 是否去除反斜杠
export const routeContains = (path, type = 1) => {
  if (type === 1) {
    return ROUTE_FIX.some((item) => path.startsWith(item))
  }
  return ROUTE_FIX.map((item) => item.slice(1)).some((item) =>
    path.startsWith(item)
  )
}

// 根据前缀生成正则表达式、实现别名匹配
export const reRouteFix = () => {
  const filterFix = ROUTE_FIX.map((item) => item.slice(1)).join('|')
  return `/(${filterFix})`
}

// 根据前缀生成正则表达式、实现别名匹配
export const setRouteBase = (ssrLocationParams) => {
  const { pathname } = getLocation(ssrLocationParams)
  const lastIndex = pathname.lastIndexOf('/') >= 3
  if (lastIndex) {
    return pathname.slice(0, 3)
  } else {
    // 再次判断如果是： /br 、 /my 、/id 等
    const result = ROUTE_FIX.some((item) => pathname === item)
    if (result) {
      return pathname.slice(0, 3)
    }
    return '/'
  }
}
